import React from 'react';
import { TipsMapFunType, TipsMapType } from '../index';
import { CONTACT_NAME, CONTACT_EMAIL } from '@op/constants';

export const summaryHeadText: TipsMapType = {
  en: (
    <>
      The real-time data of the current day is displayed by default. If there is
      no data, please change the date filter to another date.
      <br />
      Summary page can only select a single day, and do not automatically
      inherit other page dates.
    </>
  ),
  zh: (
    <>
      默认展示当天实时数据，如无数据，请更改日期筛选到其他日期查看。
      <br />
      此页面因时间只能单选某日，暂不自动继承其他页面日期。
    </>
  ),
};

export const summaryHotContentPositiveText: TipsMapType = {
  en: 'DataBrain did NLP clustering through all the positive comments to find the most discussed positive events.',
  zh: 'DataBrain 将通过所有正面评论进行NLP聚类，得出讨论度最多的正面事件。',
};

export const summaryHotContentNegativeText: TipsMapType = {
  en: 'DataBrain did NLP clustering through all the negative comments to find the most discussed negative events.',
  zh: 'DataBrain 将通过所有负面评论进行NLP聚类，得出讨论度最多的负面事件。',
};

export const summaryTopicTrackingTipsText: TipsMapType = {
  en: `Topics are pre-configured and can be applied to topic classification of reviews through keyword matching or algorithm models. Please contact @${CONTACT_NAME} for topic configuration.`,
  zh: `话题为事先配置，可通过关键词匹配或算法模型应用在评论的话题分类中。话题配置请联系@${CONTACT_NAME}。`,
};

export const summaryMainChangeTopicsTipsText: TipsMapType = {
  en: `Rules for Main Change Topics: In the left topic line chart, calculate the change rate of the start date and end date of all topics under the current indicator, and take the top three topics as the main change topics. If the date is set to one day, one week, or one month, the change rate between the date and the previous day, one week, or one month is calculated.`,
  zh: '主要变动话题取值规则：在左侧话题折线图中，计算当前指标下所有话题的起始日期与结束日期的变化率，取前三话题作为主要变动话题。其中单日/单周/单月，分别与前1天/前1周/前1个月的变化率进行计算。',
};

export const summaryRequiredKeywordsTitleTips: TipsMapType = {
  en: 'A review containing all Must Have Keywords and at least one Optional Keyword can be tagged as the current topic.',
  zh: '若某条评论包含全部的必选关键词及至少1个候选关键词时，可被标注为当前话题。',
};

export const summaryRequiredKeywords: TipsMapType = {
  en: 'Must Have Keywords: For topic tagging, only one of the keywords separated by commas on the same line needs to appear in a review, while all keywords on different lines must be present to meet the tagging criteria.',
  zh: '必选关键词：话题标注时，同一行的关键词只需出现其中一个，而不同行的关键词必须全部出现，才满足标注条件。',
};

export const summaryOptionalKeywords: TipsMapType = {
  en: 'Optional keywords: Keywords separated by commas on the same line are considered to be in an "OR" relationship, meaning a review can be tagged as the current topic if it contains any one of these keywords.',
  zh: '候选关键词：同一行用逗号分隔的关键词之间是"或"的关系，评论中出现其中任一关键词即可标记为当前话题。',
};

export const summaryPositiveTips: TipsMapType = {
  en: (
    <>
      Calculation method: <br />
      Positive topic: After classifying all mentions by topic, calculate the
      mentions and sentiment score of each topic. Topics with an sentiment score
      higher than 3.5 are positive topics.
    </>
  ),
  zh: (
    <>
      计算规则：
      <br />
      正面话题：将所有声量按话题分类后，计算各个话题的声量及情感分。情感分高于
      3.5 的话题为正面话题。
    </>
  ),
};

export const summaryNegativeTips: TipsMapType = {
  en: (
    <>
      Calculation method: <br />
      Negative topic: After classifying all mentions by topic, calculate the
      mentions and sentiment score of each topic. Topics with an sentiment score
      lower than 2.5 are negative topics.
    </>
  ),
  zh: (
    <>
      计算规则：
      <br />
      负面话题：将所有声量按话题分类后，计算各个话题的声量及情感分。情感分低于
      2.5 的话题为负面话题。
    </>
  ),
};

export const summaryDisabledTips: TipsMapType = {
  en: 'This tier 1 topic is not in the filtered topic list.',
  zh: '筛选后的话题列表，暂无该话题。',
};

export const summaryNotFoundDisabledTips: TipsMapType = {
  en: `The topic in your collection has become invalid in the topic configuration table. Please update your collection or contact Mia(@${CONTACT_NAME}) to update the topic.`,
  zh: `您收藏的话题在配置码表中已失效，请更新收藏或联系Mia(@${CONTACT_NAME})更新话题。`,
};

export const keywordCorrelationMinCorrelationTips: TipsMapType = {
  en: (
    <>
      This page uses PMI (Pointwise Mutual Information) to measure the relevance
      of keywords.
      <br />
      PMI is the ratio of the probability of two keywords co-occurring in the
      text to the product of their individual probabilities, and then taking the
      logarithm. It means that if two keywords x and y are independent, that is,
      unrelated, then their joint probability is equal to the product of their
      individual probabilities, and the PMI formula calculates a relevance
      result of zero.
      <br />
      For example, if "BUG" and "version update" are unrelated, then the
      probability of "BUG" and "version update" co-occurring should be equal to
      the probability of "BUG" and "version update" occurring separately, and
      PMI will be 0.
      <br />
      The larger the PMI value, the more relevant the two keywords are, and the
      smaller the PMI value, the less relevant they are.
    </>
  ),
  zh: (
    <>
      本页使用PMI (点互信息)来衡量关键词的相关性。
      <br />
      PMI为两个关键词在文本中共同出现的概率与它们单独出现的概率之比，然后取对数。其表达的含义是如果两个事件x和y是独立的，即不相关的，那么它们同时发生的概率就等于它们各自发生的概率的乘积，此时PMI公式计算出相关性为0。
      <br />
      例如，如果关键词"BUG"和"版本更新"无关，那"BUG"和"版本更新"同时出现的概率应该等于"BUG"和"版本更新"分别出现的概率，PMI
      将等于0。
      <br />
      PMI值越大，说明两个关键词之间越相关，越小说明越不相关。
    </>
  ),
};

export const keywordCorrelationMinFrequencyTips: TipsMapType = {
  en: (
    <>
      The frequency indicates the individual occurrence frequency of a keyword.
      <br />
      For example, in the sentence "love love love this game", the word
      frequency of "Love" is 3.
    </>
  ),
  zh: (
    <>
      词频表示关键字单独出现的频率。
      <br />
      例如，1个句子中出现"love love love this game"，"Love" 词频为3。
    </>
  ),
};

export const keywordCorrelationCloudTips: TipsMapType = {
  en: (
    <>
      Based on the NLP word association table, 20 anchor keywords are selected
      and displayed in the word cloud according to the keyword frequency in the
      selected time period. <br />
      For each anchor keyword, the 5 co-occurrence words with the highest degree
      of correlation are found, and the relationship between the anchor keywords
      and the co-occurrence words is shown with lines.
      <br />
      The larger the word bubble, the higher the frequency of the word. The
      thicker the line, the higher the degree of correlation.
    </>
  ),
  zh: (
    <>
      基于NLP关联词统计表，按照所选时间段内的关键词词频，选出20个核心关键词显示在词云图中。
      <br />
      对于这些核心关键词，各找出与之关联度最高的5个二元词。并用连线表示核心关键词和二元词的关联关系。
      <br />
      词云气泡越大，表示词频越大。连接线越粗，表示关联度越高。
    </>
  ),
};

export const keywordDistanceTips: TipsMapType = {
  en: (
    <>
      Distance refers to the distance between keywords. For example, in the
      sentence "Good game", the word distance between "good" and "game" is 1.
    </>
  ),
  zh: (
    <>
      词距表示关键词之间的距离。例如 "Good game" 句子中，good 距离 game 距离
      为1。
    </>
  ),
};

export const keywordCorrelationWordsTips: TipsMapType = {
  en: (
    <>
      To preserve the data of co-occurring phrases that have analytical value,
      the mention statistics of this page will filter out valuable co-occurring
      phrases based on the content of the reviews, and then count the number of
      reviews that contain the correlation keyword. The other pages of Opinions
      only directly count the number of reviews where the correlation keyword
      appears. Therefore, the correlation keyword mentions on other pages may be
      greater than the correlation keyword mentions on this page.
    </>
  ),
  zh: (
    <>
      为了保留有分析价值的关联词组数据，关联词页的声量统计将根据评论的内容筛选出有价值的关联词组，再依此统计包含该关键词的评论数。而舆情其他页面仅直接统计关键词出现的评论条数。所以其他页面的关键词声量可能大于本页关键词声量。
    </>
  ),
};

export const topicTrackTopicSettingTips: TipsMapType = {
  en: (
    <>
      The selected tier1 topic will be displayed in the left-hand shortcut
      positioning area.
      <br />
      The selected tier2 topic will be displayed in the topic chart below, while
      any unselected tier2 topics under the tier1 topic will be hidden.
      <br />
      After modifying the options, click on the blank area to take effect.
    </>
  ),
  zh: (
    <>
      选中的一级话题将展示在左侧快捷定位区。
      <br />
      选中的二级话题将在下方话题图表中显示，同时隐藏所属一级话题下未选中的其他二级话题。
      <br />
      修改选项后，点击空白处即生效。
    </>
  ),
};

export const hotContentTranslateTips: TipsMapType = {
  en: 'The highlighted clauses in the comments are strongly related to the event. Currently, only English clauses are supported for highlighting.',
  zh: '评论高亮的分句为评论中与事件强相关的部分，目前仅支持英文的分句高亮展示。',
};

export const summaryKeyTopicTips: TipsMapType = {
  en: `Key Topic are configured by DataBrain. For any modifications, please contact ${CONTACT_EMAIL}.`,
  zh: `核心话题由DataBrain配置，如需修改请联系${CONTACT_EMAIL}。`,
};

export const summaryTopicPerformanceTips: TipsMapType = {
  en: (
    <>
      Daily GPT summaries of the key topics are routinely generated for some
      games, please contact {CONTACT_EMAIL} for routine generation
      requests
      <br />
      <br />
      Click the "Reset" button above and select a single day to view the routine
      report generated in history（Starting from 2024-11-29）
    </>
  ),
  zh: (
    <>
      仅部分游戏的核心话题例行生成每日GPT总结，如有例行生成需求，请联系{CONTACT_EMAIL}
      <br />
      <br />
      点击上方"重置"按钮，选择单日，可查看历史生成的例行报告（从2024-11-29开始）
    </>
  ),
};

export const summaryMentionsRatioTips: TipsMapType = {
  en: (
    <>
      Mention%:The proportion of topic mentions in total mentions. <br />
      The topic filter does not affect the total mentions calculation, and all
      reviews, regardless of whether they match the topic, are counted in the
      total mentions.
    </>
  ),
  zh: (
    <>
      声量占比：该话题声量占总声量的比例。 <br />
      话题筛选器不影响总声量计算，所有评论无论是否命中话题均计入总声量。
    </>
  ),
};

export const summaryNegativeRatioTips: TipsMapType = {
  en: (
    <>
      Negative%: The proportion of negative mentions in total mentions. <br />
      The topic filter does not affect the total mentions calculation, and all
      reviews, regardless of whether they match the topic, are counted in the
      total mentions.
    </>
  ),
  zh: (
    <>
      负面声量占比：负面声量占总声量的比例。 <br />
      话题筛选器不影响总声量计算，所有评论无论是否命中话题均计入总声量。
    </>
  ),
};

export const summaryPositiveRatioTips: TipsMapType = {
  en: (
    <>
      Positive%: The proportion of positive mentions in total mentions.
      <br />
      The topic filter does not affect the total mentions calculation, and all
      reviews, regardless of whether they match the topic, are counted in the
      total mentions.
    </>
  ),
  zh: (
    <>
      正面声量占比：正面声量占总声量的比例。 <br />
      话题筛选器不影响总声量计算，所有评论无论是否命中话题均计入总声量。
    </>
  ),
};

export const summaryPositiveAndNegativeRatioTips: TipsMapType = {
  en: (
    <>
      Negative%: The proportion of negative mentions in total mentions. <br />
      Positive%: The proportion of positive mentions in total mentions. <br />
      The topic filter does not affect the total mentions calculation, and all
      reviews, regardless of whether they match the topic, are counted in the
      total mentions.
    </>
  ),
  zh: (
    <>
      负面声量占比：负面声量占总声量的比例。
      <br />
      正面声量占比：正面声量占总声量的比例。
      <br />
      话题筛选器不影响总声量计算，所有评论无论是否命中话题均计入总声量。
    </>
  ),
};

const summaryTitleOneTips: TipsMapType = {
  en: <>Updates are performed twice daily at 9:00 AM and 5:00 PM.</>,
  zh: <>当日进行两次更新，分别为早上九点及下午五点。</>,
};

const summaryTitleTwoTips: TipsMapType = {
  en: <>The event is updated every two hours, starting from 00:00.</>,
  zh: <>当日从0点开始，每两小时更新一次事件。</>,
};

export const getSummaryTitleTips: TipsMapFunType = (id): TipsMapType => {
  const summaryTitleTipsMap: any = {
    u00451b3c0d1ca31cb29eec710f659018: summaryTitleOneTips,
    e11000000311: summaryTitleOneTips,
    e7f672beaa5fddd166df98bc046ba4bd4: summaryTitleTwoTips,
  };

  const tips = summaryTitleTipsMap[id];

  return tips;
};

export const summaryCommonSentimentTips: TipsMapType = {
  en: (
    <>
      Sentiment Calculation Rules:
      <br />
      The sentiment score for a topic is calculated by averaging the sentiment
      ratings (1-5 scale) of all related content based on full-text analysis.
      <br />
      Example: For Topic A with only 1 review rated 1 (negative), the sentiment
      score = 1.
    </>
  ),
  zh: (
    <>
      情感分计算规则： <br />
      对话题下所有内容的全文进行情感打分（1-5分），取平均值作为情感分。
      <br />
      例如：A话题只有1条评论，评论的情感分为1分（负面），则该情感分为1分。
    </>
  ),
};

export const summaryTopicSentimentTips: TipsMapType = {
  en: (
    <>
      Topic Sentiment Calculation Rules:
      <br />
      The system calculates sentiment scores (1-5 scale) only for sentence
      segments that explicitly mention the target topic, then averages these
      scores to determine the topic's sentiment rating. <br />
      Example: Topic A has only 1 review , and the sentiment score of the entire
      review is 1 (negative), but its topic A sentence scores 3 (neutral), the
      topic sentiment score = 3.
    </>
  ),
  zh: (
    <>
      话题情感分计算规则： <br />
      仅针对句子中提及该话题的部分进行情感打分（1-5分），取平均值。 <br />
      例如：A话题只有1条评论，该条评论情感分为1分（负面），但提到A话题的句子情感分为3分（中性），则A话题情感分为3分。
    </>
  ),
};

export const summaryTopicNotSentimentTips: TipsMapType = {
  en: (
    <>
      The topic sentiment score feature was launched on May 19, 2025. If you
      need to obtain historical reviews' topic sentiment scores, please contact {CONTACT_EMAIL}.
    </>
  ),
  zh: (
    <>
      话题情感分在2025年5月19日上线，如需回溯历史评论的话题情感分，请联系
      {CONTACT_EMAIL}。
    </>
  ),
};

export const showChitchatTipsMap: TipsMapType = {
  en: 'When selected, the event list will include "Chit-chat", "Overall praise and enjoyment", and "Generic negative feedback".',
  zh: '勾选后事件列表会包含“闲聊”、“总体好评与喜爱”，以及“通用差评”事件。',
};